/**
 * @generated SignedSource<<e7ff92ec489d888536b8355eaec54b2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAuthMeQuery$variables = {};
export type useAuthMeQuery$data = {
  readonly me: {
    readonly " $fragmentSpreads": FragmentRefs<"useAuth_MeFragment">;
  } | null;
};
export type useAuthMeQuery = {
  response: useAuthMeQuery$data;
  variables: useAuthMeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  (v0/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentSubscription",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthMeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useAuth_MeFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useAuthMeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canAccessMarketplace",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PartnerNode",
            "kind": "LinkedField",
            "name": "partner",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canViewPortfolio",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyNode",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "isAccepted",
                        "value": true
                      }
                    ],
                    "concreteType": "OfferNodeConnection",
                    "kind": "LinkedField",
                    "name": "offers",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OfferNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OfferNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v2/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "offers(isAccepted:true)"
                  },
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PartnerNodeConnection",
                    "kind": "LinkedField",
                    "name": "partners",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PartnerNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartnerNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserNode",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PartnerNode",
                                    "kind": "LinkedField",
                                    "name": "partner",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v0/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v0/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v0/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "actor",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isActorInterface"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastActiveAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "actor",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v5/*: any*/),
                      (v0/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileNode",
                            "kind": "LinkedField",
                            "name": "spotifyProfile",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v0/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ArtistNode",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              (v0/*: any*/),
              (v6/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyNode",
                    "kind": "LinkedField",
                    "name": "company",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/),
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "PartnerNode",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ArtistNode",
            "kind": "LinkedField",
            "name": "artist",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visible",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "partnershipStatus",
                "storageKey": null
              },
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numIntrosSendable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nextIntroSendableAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stripeConnectedAccountApiId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numUnreadMessages",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stripePriceId",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatNodeConnection",
            "kind": "LinkedField",
            "name": "chats",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChatNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v2/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "059c0a3d2a5b2876b7a1bac53b3d667d",
    "id": null,
    "metadata": {},
    "name": "useAuthMeQuery",
    "operationKind": "query",
    "text": "query useAuthMeQuery {\n  me {\n    ...useAuth_MeFragment\n    id\n  }\n}\n\nfragment AuthUserAvatarName_authUser on UserNode {\n  artist {\n    visible\n    partnershipStatus\n    id\n  }\n  actor {\n    __typename\n    ...AvatarName_actor\n    id\n  }\n}\n\nfragment AvatarIcon_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    lastActiveAt\n    ...useUserThumbnailUrl_user\n    id\n  }\n}\n\nfragment AvatarName_actor on ActorInterface {\n  __isActorInterface: __typename\n  __typename\n  slug\n  displayName\n  ...AvatarIcon_actor\n  ... on PartnerNode {\n    company {\n      slug\n      displayName\n      id\n    }\n  }\n}\n\nfragment ChatThread_authUser on UserNode {\n  id\n  actor {\n    __typename\n    id\n    ...AvatarIcon_actor\n  }\n  userType\n  artist {\n    visible\n    id\n  }\n}\n\nfragment FundPortfolioPage_authUser on UserNode {\n  partner {\n    canViewPortfolio\n    id\n  }\n}\n\nfragment Inbox_authUser on UserNode {\n  numUnreadMessages\n}\n\nfragment ManageSubscription_subscribedUser on UserNode {\n  id\n  partner {\n    displayName\n    id\n  }\n}\n\nfragment PrivateRoute_authUser on UserNode {\n  id\n  email\n  userType\n  name\n  canAccessMarketplace\n}\n\nfragment RowFund_userArtist on UserNode {\n  artist {\n    ...useArtistCanMessageCompany_artist\n    id\n  }\n}\n\nfragment UserInfo_authUser on UserNode {\n  actor {\n    __typename\n    ...AvatarIcon_actor\n    id\n  }\n}\n\nfragment UserNav_authUser on UserNode {\n  userType\n}\n\nfragment useArtistCanMessageCompany_artist on ArtistNode {\n  numIntrosSendable\n  nextIntroSendableAt\n}\n\nfragment useArtistThumbnailUrl_artist on ArtistNode {\n  thumbnailUrl\n  spotifyProfile {\n    thumbnailUrl\n    id\n  }\n}\n\nfragment useAuth_MeFragment on UserNode {\n  id\n  email\n  userType\n  ...useCanAccessMarketplace_authUser\n  ...usePartnerCanViewDeals_authUser\n  ...PrivateRoute_authUser\n  ...UserInfo_authUser\n  ...AuthUserAvatarName_authUser\n  ...ChatThread_authUser\n  ...useOfferNextStep_authUser\n  ...Inbox_authUser\n  ...RowFund_userArtist\n  ...UserNav_authUser\n  ...FundPortfolioPage_authUser\n  ...useSubscribedUser\n  ...useUserCanViewChats_authUser\n}\n\nfragment useCanAccessMarketplace_authUser on UserNode {\n  canAccessMarketplace\n}\n\nfragment useOfferNextStep_authUser on UserNode {\n  id\n  stripeConnectedAccountApiId\n}\n\nfragment usePartnerCanViewDeals_authUser on UserNode {\n  partner {\n    canViewPortfolio\n    company {\n      offers(isAccepted: true) {\n        edges {\n          node {\n            __typename\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useSubscribedUser on UserNode {\n  ...ManageSubscription_subscribedUser\n  stripePriceId\n  currentSubscription\n  partner {\n    company {\n      partners {\n        edges {\n          node {\n            user {\n              ...ManageSubscription_subscribedUser\n              currentSubscription\n              id\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useUserCanViewChats_authUser on UserNode {\n  chats {\n    edges {\n      node {\n        __typename\n        id\n      }\n    }\n  }\n}\n\nfragment useUserThumbnailUrl_user on UserNode {\n  actor {\n    __typename\n    thumbnailUrl\n    ...useArtistThumbnailUrl_artist\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "39acc2380f846899dd894e31d329379a";

export default node;
